import Icon from '../../components/Icon.vue'

Icon.register({"brands/vine":{"width":384,"height":512,"paths":[{"d":"M384 254.7V306.8C365.6 311 347.1 312.9 331.9 312.9 295 390.3 228.9 456.7 206.8 469.1 192.8 477 179.7 477.5 164.1 468.3 137 452 34.2 367.7 0 102.7H74.5C93.2 261.8 139 343.4 189.3 404.5 217.2 376.6 244.1 339.4 264.9 297.6 215.1 272.3 184.8 216.7 184.8 152 184.8 86.4 222.5 36.9 287 36.9 401.9 36.9 393.2 164.8 368.6 218.4 368.6 218.4 322.2 227.6 305.1 197.9 308.5 186.6 313.3 167.1 313.3 149.4 313.3 118.1 302 102.8 284.9 102.8 266.7 102.8 254.1 119.9 254.1 152.8 254.2 232 313.5 271.5 384 254.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/vine.js
// module id = null
// module chunks = 